export default __webpack_public_path__ + "images/bg_color.2aba1e8.svg";